import css from './index.module.scss';
import KlaviyoForm from '@/components/SignUpForm/Klaviyo';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import { getCurrTemplate } from '../EmailDataMap';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect, useState } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import Popup from '../Popup';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useRouter, useLang, useRef, gtm } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const signUpEmail = getCurrTemplate(locale);
    const [openPopup, setOpenPopup] = useState(false);
    const signUpRef = useRef(null);

    useEffect(() => {
        if (['jp', 'es'].includes(locale)) return;

        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.firstPage`,
            offset: 65, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            '.firstPage .email-box',
            0.3,
            {
                opacity: 0,
                y: 200,
            },
            {
                opacity: 1,
                y: 0,
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.firstPage .mask',
            0.3,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        timelineA1.add(tweenA1).add(tweenA2, 0);
        sceneA1.setTween(timelineA1);
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.firstPage} firstPage GtmModuleData-section`} data-section-id={css.firstPage} data-section-title={t('delta2.title')}>
            <div className="sticky-box">
                <div className="first-img">
                    <EFPic name={['kv.webp', 'kv.jpg']} loading="eager" alt={t('delta2.title')} />
                </div>
                <div className="v-msg">
                    <div className="v-msg-1">{t('delta2.title')}</div>
                    <div className="v-msg-2">{t('delta2.title2')}</div>
                </div>
                <div className="email-box">
                    <div className="msg-add">{signUpEmail.type && t('delta2.title_add')}</div>
                    <div className="email-msg">{signUpEmail.type && t('delta2.email_msg_new')}</div>
                    {locale === 'za' && signUpEmail.type && <div className="more">{t('delta2.sec1_more')}</div>}
                    <div className="input-box">
                        {signUpEmail.type === 'mailchimp' && (
                            <Mailchimp
                                scriptUrl={signUpEmail.scriptUrl}
                                successCallback={() => {
                                    setOpenPopup(true);
                                    signUpRef.current?.resetFiled();
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'get_preview',
                                            status: 'success',
                                        });

                                        window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                                errorCallback={() => {
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'get_preview',
                                            status: 'fail',
                                        });
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                            >
                                <signUpEmail.Component ref={signUpRef} action={signUpEmail.action} extraFields={signUpEmail.extraFields} />
                            </Mailchimp>
                        )}
                        {signUpEmail.type === 'klaviyo' && (
                            <KlaviyoForm
                                extra_properties={{
                                    $source: signUpEmail.source,
                                    $method_type: 'Klaviyo Form',
                                    $method_id: 'embed',
                                    $consent_version: 'Embed default text',
                                }}
                                successCallback={() => {
                                    setOpenPopup(true);
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'get_preview',
                                            status: 'success',
                                        });
                                        window?.fbq && window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }}
                                errorCallback={() => {
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'get_preview',
                                            status: 'fail',
                                        });
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }}
                            >
                                <signUpEmail.Component list_id={signUpEmail.list_id} />
                            </KlaviyoForm>
                        )}
                    </div>
                </div>
                <div className="mask"></div>
            </div>
            <Popup visible={openPopup} onCancel={() => setOpenPopup(false)} />
        </div>
    );
}
